<template>
  <footer>
    <p class="copyright" v-html="webContents.article.copyRight"></p>
  </footer>
</template>
<script>
export default {
  props: ["corpParam"],
  computed: {
    screenId: () => "FOOTER",
    webContents() {
      let ret = { article: "", images: "" };
      if (this.corpParam && this.corpParam.memberRegistrationWebContents) {
        ret = JSON.parse(this.corpParam.memberRegistrationWebContents)[this.screenId];
      }
      return ret;
    },
  },
};
</script>
